import Repository from "./RepositoryLocal";

const resource = "/kawabou";
export default {
  /**
   * アクセスログ(ページログ)出力用途の空ファイル取得
   * (ログ自体はサーバのアクセスログの仕組みを利用)
   * @param {*} params ログ出力パラメータ
   */
  forPageLog(params) {
    return Repository.get(`${resource}/page_log/kawabou.json`, {
      params: params,
    });
  },
};
